import { DialogContextProps } from "@interfaces/System/DialogContextProps";
import { Button, DialogActions, DialogContent } from "@material-ui/core";
import { ModalContentLoading } from "@components/Common/Modal";
import React, { useRef } from "react";
import { storeService } from "@services";
import { useSnackbar } from "notistack";
import { useAsync, useTable } from "@hooks";
import { PriceForm } from "@components/Forms/Price";
import { CreatePriceDto, UpdatePriceDto } from "@dto/PriceDto";

const PriceDialogContext = ({ onClose, modalProps }: DialogContextProps) => {
    const { itemId } = { ...modalProps };

    const formRef = useRef<HTMLFormElement>();
    const { enqueueSnackbar } = useSnackbar();
    const { updateData } = useTable();

    const { data, loadingStatus } = useAsync(storeService.getOneStorePrice, {
        functionArgs: [itemId],
        canLoad: !!itemId,
    });

    const invokeSubmit = () => {
        formRef.current!.handleSubmit();
    };

    const handleCreatePrice = async (values) => {
        try {
            const dto = storeService.plainToClass(CreatePriceDto, values);
            await storeService.createPrice(dto);
            enqueueSnackbar("Цена успешно добавлена", {
                variant: "success",
            });
            onClose();
            updateData();
        } catch (err) {
            const message = err.response?.data?.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при добавлении цены", {
                variant: "error",
            });
        }
    };

    const handleUpdatePrice = async (values) => {
        if (!data) return;

        try {
            const dto = storeService.plainToClass(UpdatePriceDto, values);
            await storeService.updatePrice(data.id, dto);
            enqueueSnackbar("Цена успешно обновлена", {
                variant: "success",
            });
            onClose();
            updateData();
        } catch (err) {
            const message = err.response?.data?.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при обновлении цены", {
                variant: "error",
            });
        }
    };

    return (
        <>
            <DialogContent>
                {loadingStatus === "loading" && <ModalContentLoading />}

                {(loadingStatus === "loaded" || loadingStatus === "inactivity") && (
                    <PriceForm
                        ref={formRef}
                        data={data}
                        onSubmit={data ? handleUpdatePrice : handleCreatePrice}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button color="default" onClick={onClose}>
                    Отмена
                </Button>
                <Button color="primary" variant="contained" onClick={invokeSubmit}>
                    Сохранить
                </Button>
            </DialogActions>
        </>
    );
};

export default PriceDialogContext;
